import { apiRequest } from "./apiClient";

const BASE = "/assistant-notifications";

export async function aiNotifConfigGetir() {
  const data = await apiRequest(`${BASE}/config`);
  return data?.config || null;
}

export async function aiNotifConfigKaydet(config) {
  const data = await apiRequest(`${BASE}/config`, {
    method: "PUT",
    body: JSON.stringify(config),
  });
  return data?.config || null;
}

export async function aiNotifSabahOzetiCalistir() {
  return apiRequest(`${BASE}/run/daily-summary`, { method: "POST" });
}

export async function aiNotifAcilUyariCalistir() {
  return apiRequest(`${BASE}/run/urgent-alerts`, { method: "POST" });
}

export async function aiNotifHaftalikOzetCalistir() {
  return apiRequest(`${BASE}/run/weekly-digest`, { method: "POST" });
}

export async function aiNotifAkillıIpucuCalistir() {
  return apiRequest(`${BASE}/run/smart-insights`, { method: "POST" });
}

export async function aiNotifLoglarGetir(limit = 30) {
  const data = await apiRequest(`${BASE}/logs?limit=${limit}`);
  return data?.logs || [];
}

export async function aiNotifStatsGetir() {
  const data = await apiRequest(`${BASE}/stats`);
  return data?.stats || {};
}
